import { getToken } from '@/util/auth'
import { Message } from 'element-ui'
import { ref } from '@vue/composition-api'

const exportLoading = ref(false)

const computedDate = () => {
  const date = new Date()
  const y = date.getFullYear()
  let m = date.getMonth()
  let d = date.getDate()
  if ((m + '').length === 1) {
    m = '0' + (m + 1)
  }
  if ((d + '').length === 1) {
    d = '0' + d
  }
  return y + m + d
}

const exportToExcel = (method, link, data, filename) => {
  exportLoading.value = true
  var xhr = new XMLHttpRequest()
  xhr.open(method, link, true)
  xhr.responseType = 'blob'
  xhr.setRequestHeader('Authorization', 'Bearer ' + getToken())
  xhr.setRequestHeader('Content-Type', 'application/json')
  xhr.onload = function () {
    exportLoading.value = false
    if (xhr.status === 202) {
      Message.warning('暂无数据')
    }
    if (xhr.status === 500) {
      Message.error('服务器开小差了')
    }
    if (xhr.status === 200) {
      const blob = new Blob([xhr.response], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      var a = document.createElement('a')
      var url = window.URL.createObjectURL(blob)
      a.href = url
      if (filename) {
        a.download = filename + computedDate()
      } else {
        const contentDisposition = xhr.getResponseHeader('Content-Disposition')
        const result = contentDisposition.split('filename=')[1]
        a.download = decodeURIComponent(result)
      }
      a.target = '_blank'
      a.click()
      Message.success('下载中，请查看浏览器下载内容')
      window.URL.revokeObjectURL(url)
    }
  }
  xhr.send(JSON.stringify(data))
}

export default exportToExcel
export { exportLoading }
